/*
 * Module for the MemberDirect Enrollment Correspondence Distribution job criteria page
 */
rs.module("content/jobs/criteria/memberdirectenrollmentcorrdist",

    [ "common/visibility" ],

    function (visibility) {

        // Initialize the page
        function initialize(jsSelectors, typeOptions) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            //var loadingSpinner = criteria.js(jsSelectors.loadingSpinner);
            var correspondenceSelect = criteria.js(jsSelectors.correspondenceTypeDropDown);
            var individualSections = criteria.js(jsSelectors.individualSections, { multiple: true });
            var batchSections = criteria.js(jsSelectors.batchSections, { multiple: true });

            // Setup the correspondence type change event
            correspondenceSelect.change(changeSections)

            // Function to change between the individual fields and batch fields
            function changeSections() {

                // Hide all
                visibility.hide(individualSections);
                visibility.hide(batchSections);

                // Show sections based on selection
                switch (correspondenceSelect.val()) {
                    case typeOptions.individual:
                        visibility.show(individualSections);
                        break;

                    case typeOptions.batch:
                        visibility.show(batchSections);
                        break;

                    default:
                        break;
                }

            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);